import React, { useState } from 'react';
import Header from '../Core/Header';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,BarChart, Bar, 
 
} from "recharts";


import { PieChart, Pie, Cell,  } from 'recharts';
import { doctors } from '../../Assets/dummyDoc';
import { useNavigate } from 'react-router-dom';


const data2 = [
  { month: "Jan", profit: 1500, expenses: 900, patients: 50 },
  { month: "Feb", profit: 2200, expenses: 1200, patients: 170 },
  { month: "Mar", profit: 3800, expenses: 1400, patients: 1090 },
  { month: "Apr", profit: 3200, expenses: 2000, patients: 330 },
  { month: "May", profit: 5000, expenses: 2800, patients: 470 },
];



const data = [
  { name: 'Daily', admissions: 50 },
  { name: 'Weekly', admissions: 75 },
  { name: 'Monthly', admissions: 150 },
  { name: 'Yearly', admissions: 200 },
  { name: 'Year', admissions: 250 },
];




const Dashboard = () => {
     const[list,setList]=useState(doctors)
     const[manage,setManage]=useState("")
     const navigate=useNavigate()
  return (
   <div style={{height:"100vh",width:"100%",overflow:"hidden"}}>
    <Header/>
    <section style={{marginTop:"80px",border:"1px solid black",width:"100%",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #363658ff, rgb(194, 193, 193), #37385cff)",padding:"10px",display:"flex",justifyContent:"space-between"}}>
        <div 
      style={{
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "25px",
  width: "20%",
  background: "rgba(255, 255, 255, 0.1)", // semi-transparent
  padding: "20px",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)", // for Safari
  borderRadius: "12px",
  border: "1px solid rgba(219, 218, 218, 0.2)"
}}
      >
            <p style={{fontSize:"20px",backgroundColor:"#2a3ff7ff",padding:"8px",borderRadius:"6px",fontWeight:"700",color:"white",width:"90%",display:"flex",alignItems:"center",cursor:"pointer"}}>
                <img src='/Assets/add.png' style={{width:"30px",height:"30px"}}/>
                <span>Add to platform</span></p>
            <p  style={{fontSize:"16px",backgroundColor:"#ffffffff",padding:"8px",borderRadius:"6px",fontWeight:"700",color:"#071e47ff",width:"fit-content",display:"flex",gap:"4px",alignItems:"center",cursor:"pointer"}}>
                <img src='/Assets/add-user.png' style={{width:"20px",height:"20px"}}/>
                <span>Admit New Patient</span>
                 <img src='/Assets/right.png' style={{width:"20px",height:"14px"}}/>
                </p>
          {/* manages */}
             
             <div onMouseEnter={()=>setManage("doctor")} onMouseLeave={()=>setManage("")}
             style={{fontSize:"16px",backgroundColor:"#1272aaff",padding:"1px",borderRadius:"6px",color:"#ffffffff",width:"90%",display:"flex",flexDirection:"column",gap:"4px",cursor:"pointer"}}>
              <p  
             style={{fontSize:"16px",backgroundColor:"#1272aaff",padding:"8px",borderRadius:"6px",fontWeight:"700",color:"#ffffffff",width:"100%",display:"flex",gap:"4px",alignItems:"center",cursor:"pointer"}}>
                <img src='/Assets/user-1.png' style={{width:"20px",height:"20px"}}/>
                <span> Doctors manage</span>
                 {manage!=="doctor"&& <img src='/Assets/right.png' style={{width:"20px",height:"14px"}}/>}
                </p>
               {manage==="doctor"&& <div style={{transition:"0.2 sec ",padding:0,margin:0}}>
                <p className='!font-medium !hover:font-bold hover:text-red-300' onClick={()=>navigate("/find-doctors")} style={{fontSize:"14px",paddingLeft:"30px"}}>Search Doctors --{'>'}</p>
                <p onClick={()=>navigate("/view-doctors")} style={{fontSize:"14px",paddingLeft:"30px"}}>Our Doctors--{'>'}</p>
                 </div>}
                </div>
           
           <div  onMouseEnter={()=>setManage("hospital")} onMouseLeave={()=>setManage("")}
           style={{fontSize:"16px",backgroundColor:"rgb(255, 255, 255)",padding:"0px",borderRadius:"6px",fontWeight:"700",color:"#071e47ff",width:"90%",display:"flex",flexDirection:"column",gap:"4px",cursor:"pointer"}}> 
            <p  onClick={()=>navigate("/view-hospitals")}
            style={{fontSize:"16px",backgroundColor:"rgb(255, 255, 255)",padding:"8px",borderRadius:"6px",fontWeight:"700",color:"#071e47ff",width:"100%",display:"flex",gap:"4px",alignItems:"center",cursor:"pointer"}}>
                <img src='/Assets/health.png' style={{width:"20px",height:"20px"}}/>
                <span>Hospitals manage</span>
                {manage!=="hospital"&& <img src='/Assets/right.png' style={{width:"20px",height:"14px"}}/>}
                </p>
                 {manage==="hospital"&& <div style={{transition:"0.2 sec ",padding:0,margin:0}}>
               <p onClick={()=>navigate("/find-hospitals")} style={{fontWeight:"400",fontSize:"14px",paddingLeft:"30px"}}>Search Hospitals --{'>'}</p>
                <p onClick={()=>navigate("/view-hospitals")} style={{fontWeight:"400",fontSize:"14px",paddingLeft:"30px"}}>Our Hospitals --{'>'}</p>
                 </div>}
                </div>
             
             <div  onMouseEnter={()=>setManage("patient")} onMouseLeave={()=>setManage("")}
             style={{fontSize:"16px",backgroundColor:"rgb(255, 255, 255)",padding:"0px",borderRadius:"6px",color:"#071e47ff",width:"90%",display:"flex",gap:"4px",flexDirection:"column",cursor:"pointer"}}>
              <p  onClick={()=>navigate("/patients")}
             style={{fontSize:"16px",backgroundColor:"rgb(255, 255, 255)",padding:"8px",borderRadius:"6px",fontWeight:"700",color:"#071e47ff",width:"100%",display:"flex",alignItems:"center",gap:"4px",cursor:"pointer"}}>
                <img src='/Assets/add-user.png' style={{width:"20px",height:"20px"}}/>
                <span>Patients manage</span>
                 {manage!=="patient"&& <img src='/Assets/right.png' style={{width:"20px",height:"14px"}}/>}
                </p>
                 {manage==="patient"&& <div style={{transition:"0.2 sec ",padding:0,margin:0}}>
                <p className='!font-medium !hover:font-bold hover:text-red-300' onClick={()=>navigate("/find-doctors")} style={{fontSize:"14px",paddingLeft:"30px"}}>Pateint data upload --{'>'}</p>
                <p onClick={()=>navigate("/patients")} style={{fontSize:"14px",paddingLeft:"30px"}}>Our Patients--{'>'}</p>
                 </div>}</div>

              <p  style={{fontSize:"16px",backgroundColor:"#000000ff",padding:"8px",borderRadius:"6px",fontWeight:"700",color:"#ffffffff",width:"fit-content",display:"flex",gap:"4px",alignItems:"center",cursor:"pointer",bottom:"10px",position:"absolute"}}>
                <img src='/Assets/turn-off.png' style={{width:"20px",height:"20px",backgroundColor:"white",padding:"2px",borderRadius:"50%"}}/>
                <span>Log Out</span>
                 <img src='/Assets/right.png' style={{width:"20px",height:"14px"}}/>
                </p>
        </div>

        <div  style={{width:"80%",height:"100%",maxHeight:"fit-content",overflow:"auto"}}>
             <div style={{ position: "relative", width: "100%", height: "50%", borderRadius: "10px" }}>
            
            {/* NEW IMAGE */}
            <img src='/assets/doc-dash21.png' style={{ borderRadius: "10px", width: "100%", height: "100%", objectFit: "cover" }} />
            
            {/* OVERLAY SECTION - NO BLUE BACKGROUND */}
            <div style={{
              position: "absolute",
              left: "10px",
              height: "80%",
              // backgroundColor: "#3166f8ff", // REMOVED BLUE BACKGROUND as requested
              width: "60%",
              top: "24px",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              padding: "30px"
            }}>
              
              <p style={{ fontSize: "34px", fontWeight: "700", color: "white", textShadow: "0 2px 5px rgba(0,0,0,0.5)" }}>
                Welcome to DashBoard 
              </p>
              
              <div style={{ display: "flex", alignItems: "center", justifyContent: "left", gap: "20px" }}>
                {/* WHITE BUTTONS (Restored/Checked) */}
                <div onClick={() => navigate("/request")}
                  style={{ position: "relative", display: "flex", alignItems: "center", width: "120px", gap: "10px", padding: "8px", borderRadius: "8px", backgroundColor: "#fefefe", cursor: "pointer", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
                  <img src='/Assets/hospital-1.png' style={{ width: "30px", height: "30px" }} />
                  <p style={{ fontSize: "14px", fontWeight: "600", width: "50%" }}>Hospital's Request</p>
                  <p style={{
                    padding: "3px", borderRadius: "50%", color: "white", backgroundColor: "#4e0505ff", fontSize: "10px", width: "16px", height: "16px",
                    display: "flex", alignItems: 'center', justifyContent: "center", position: "absolute", top: -3, right: "0"
                  }}>3</p>
                </div>


                <div onClick={() => navigate("/request")}
                  style={{ position: "relative", display: "flex", alignItems: "center", width: "130px", gap: "10px", padding: "8px", borderRadius: "8px", backgroundColor: "#fefefe", cursor: "pointer", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}>
                  <img src='/Assets/hospital.png' style={{ width: "30px", height: "30px" }} />
                  <p style={{ fontSize: "14px", fontWeight: "600", width: "50%" }}>Diagnostic's Request</p>
                  <p style={{
                    padding: "3px", borderRadius: "50%", color: "white", backgroundColor: "#4e0505ff", fontSize: "10px", width: "16px", height: "16px",
                    display: "flex", alignItems: 'center', justifyContent: "center", position: "absolute", top: -3, right: "0"
                  }}>3</p>
                </div>

              </div>

            </div>
          </div>
           
            <div style={{position:"relative",width:"100%",height:"50%",display:"flex",alignItems:"center",justifyContent:'space-between'}}>
                <div style={{width:"50%",display:"flex",flexWrap:"wrap",overflowY:"auto",overflowX:"hidden",height:"450px",marginTop:"180px"}}>
                             {
            list.map((item)=>(
                <div style={{width:"150px",minHeight:"100px",maxHeight:"fit-content",borderRadius:"10px",padding:"4px",backgroundColor:"#90b2faff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px"
                }}>
                    <img src='/Assets/about-2.jpg' style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"10px",textAlign:"left",fontWeight:"500"}}>{item.name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'7px',fontWeight:"300",color:"#632b1dff"}}>Age:{item.Age}</span>
                            <span style={{fontSize:'7px',fontWeight:"300",color:"#122030ff"}}>{item.Specialist}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'7px',fontWeight:"300",color:"#55070aff"}}>Exp:{item.Experience}</span>
                            <span style={{fontSize:'7px',fontWeight:"300",color:"#080946ff"}}>Reg:{item.Registered}</span></p>
                        <p style={{fontSize:"5px",fontWeight:"500"}}>Assigned Hospitals</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"1px",flexWrap:"wrap"}}>
                            
                            {
                            item.Hospitals.map(i=>
                            <p style={{fontSize:"5px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>

                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"1px",flexWrap:"wrap"}}>
                            <p style={{fontSize:"5px",fontWeight:"500"}}>Assigned Diagonistic center</p><br/>
                            {
                            item.Diagonistics.map(i=>
                            <p style={{fontSize:"5px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                    </div>
            ))
            }
                </div>


                  <div  style={{width:"50%",height:"550px",display:"flex",flexDirection:"column",gap:'20px'}}> 
                          <div style={{ width: "100%", height: "250px",marginTop:"120px",padding:"17px",borderRadius:"10px",
                       backdropFilter: "blur(10px)",       // blur effect
    backgroundColor: "white", // transparent background (20% white)
    WebkitBackdropFilter: "blur(20px)",
                  }}>
      <h3 style={{fontWeight:"700"}}>Monthly Profit, Expenses and Patient Admissions</h3>

      <ResponsiveContainer>
        <LineChart data={data2} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />

          {/* Profit Line */}
          <Line type="monotone" dataKey="profit" stroke="#007bff" strokeWidth={3} />

          {/* Expenses Line */}
          <Line type="monotone" dataKey="expenses" stroke="#ff7f0e" strokeWidth={3} />

          {/* Patients Line */}
          <Line type="monotone" dataKey="patients" stroke="#28a745" strokeWidth={3} />
        </LineChart>
      </ResponsiveContainer>
                         </div>

                           <div style={{ width: '100%', height: "200px",backgroundColor:"white",borderRadius:"10px",padding:"20px" }}>
      <h3>Patient Admissions (Daily, Weekly, Monthly, Yearly)</h3>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="admissions" fill="#163158ff" />
        </BarChart>
      </ResponsiveContainer>
                          </div>
                  </div>

            
              

            </div>

        </div>
    </section>
      
    </div>
  );
}

export default Dashboard;
